export default "__VITE_ASSET__qtUhjp7S__"